import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '@/lib/analytics';

/**
 * Component to track page views in Single Page Application
 * Automatically tracks route changes and sends page views to Google Analytics
 */
export const PageViewTracker = () => {
  const location = useLocation();

  useEffect(() => {
    // Get page title from document or generate from path
    const pageTitle = document.title || getPageTitleFromPath(location.pathname);
    
    // Track page view
    trackPageView(location.pathname + location.search, pageTitle);
  }, [location]);

  return null;
};

/**
 * Generate a human-readable page title from the URL path
 */
function getPageTitleFromPath(path: string): string {
  // Remove leading slash and split by slashes
  const segments = path.replace(/^\//, '').split('/');
  
  // Convert path segments to title case
  const title = segments
    .map(segment => 
      segment
        .split('-')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ')
    )
    .join(' - ');
  
  return title || 'Home';
}
